// extracted by mini-css-extract-plugin
export default {"container":"ReferencialP_container__NY7jl","conteudo":"ReferencialP_conteudo__NTM36","desc":"ReferencialP_desc__+aGvz"};